export default "__VITE_ASSET__gXW1mnXp__"